export default __webpack_public_path__ + "media/images/borleft-onglet2-6be83a20bb96dfad6e1aaecac504f4d9.png";